import { Avatar, Badge, Box, IconButton } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import { useState } from 'react';
import PropTypes from 'prop-types';

export const AvatarPicker = ({ values, handleChange }) => {
    const [avatarSrc, setAvatarSrc] = useState(values);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        handleChange(event);
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setAvatarSrc(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <IconButton>
            <label htmlFor="add-user-avatar">
                <input
                    accept="image/*"
                    id="add-user-avatar"
                    multiple
                    type="file"
                    name="picture"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                <Badge
                    sx={{ cursor: 'pointer' }}
                    overlap="circular"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    badgeContent={
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 36,
                                height: 36,
                                borderRadius: '50%',
                                backgroundColor: '#fff',
                                boxShadow: '1px 3px 6px #0000007A'
                            }}
                        >
                            <PhotoCamera sx={{ color: '#01579B' }} />
                        </Box>
                    }
                >
                    <Avatar
                        src={avatarSrc}
                        style={{
                            width: '120px',
                            height: '120px',
                            backgroundColor: '#01579B',
                            color: '#FFFFFF99'
                        }}
                    />
                </Badge>
            </label>
        </IconButton>
    );
};

AvatarPicker.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};
